import { SystemRole } from '../Enums/system-role.enum';
import { NavItem } from '../Modules/Shared/Interfaces/nav-item.interface';

export const NAV_ITEMS: readonly NavItem[] = [
  {
    label: 'backoffice.shell.nav.dashboard',
    icon: 'space_dashboard',
    route: '/',
    minRole: SystemRole.BACKOFFICE_VIEWER,
  },
  {
    label: 'backoffice.shell.nav.organizations',
    icon: 'corporate_fare',
    route: '/organizations',
    minRole: SystemRole.BACKOFFICE_VIEWER,
  },
  {
    label: 'backoffice.shell.nav.plans',
    icon: 'sell',
    route: '/plans',
    minRole: SystemRole.BACKOFFICE_VIEWER,
  },
  {
    label: 'backoffice.shell.nav.licences',
    icon: 'confirmation_number',
    route: '/licences',
    minRole: SystemRole.BACKOFFICE_VIEWER,
  },
  {
    label: 'backoffice.shell.nav.devices',
    icon: 'devices',
    route: '/devices',
    minRole: SystemRole.BACKOFFICE_VIEWER,
  },
  {
    label: 'backoffice.shell.nav.reconciliation',
    icon: 'rule',
    route: '/reconciliation',
    minRole: SystemRole.BACKOFFICE_VIEWER,
  },
  {
    label: 'backoffice.shell.nav.users',
    icon: 'group',
    route: '/users',
    minRole: SystemRole.BACKOFFICE_AGENT,
  },
  {
    label: 'backoffice.shell.nav.rbac',
    icon: 'shield',
    route: '/rbac',
    minRole: SystemRole.BACKOFFICE_VIEWER,
  },
  {
    label: 'backoffice.shell.nav.team',
    icon: 'badge',
    route: '/team',
    minRole: SystemRole.BACKOFFICE_ADMIN,
  },
  {
    label: 'backoffice.shell.nav.onboardings',
    icon: 'how_to_reg',
    route: '/onboardings',
    minRole: SystemRole.BACKOFFICE_VIEWER,
  },
  {
    label: 'backoffice.shell.nav.ops',
    icon: 'monitor_heart',
    route: '/ops',
    minRole: SystemRole.BACKOFFICE_VIEWER,
  },
  {
    label: 'backoffice.shell.nav.webhooks',
    icon: 'webhook',
    route: '/webhooks',
    minRole: SystemRole.BACKOFFICE_VIEWER,
  },
  {
    label: 'backoffice.shell.nav.audit',
    icon: 'history',
    route: '/audit',
    minRole: SystemRole.BACKOFFICE_VIEWER,
  },
  {
    label: 'backoffice.shell.nav.settings',
    icon: 'notifications',
    route: '/settings',
    minRole: SystemRole.BACKOFFICE_VIEWER,
  },
];
